import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bitcoin': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM362.3 220.7c4.9-33-20.2-50.7-54.5-62.6l11.1-44.7-27.2-6.8-10.9 43.5c-7.2-1.8-14.5-3.5-21.8-5.1l10.9-43.8-27.2-6.8-11.2 44.7c-5.9-1.3-11.7-2.7-17.4-4.1l0-0.1-37.5-9.4-7.2 29.1s20.2 4.6 19.8 4.9c11 2.8 13 10 12.7 15.8l-12.7 50.9c0.8 0.2 1.7 0.5 2.8 0.9-0.9-0.2-1.9-0.5-2.9-0.7l-17.8 71.3c-1.3 3.3-4.8 8.4-12.5 6.5 0.3 0.4-19.8-4.9-19.8-4.9l-13.5 31.1 35.4 8.8c6.6 1.7 13 3.4 19.4 5l-11.3 45.2 27.2 6.8 11.2-44.7c6 1.6 15.7 4.1 21.7 5.6l-11.1 44.5 27.2 6.8 11.3-45.1c46.4 8.8 81.3 5.2 96-36.7 11.8-33.8-0.6-53.3-25-66 17.8-4.1 31.2-15.8 34.7-39.9zM300.2 307.8c-8.4 33.8-65.3 15.5-83.8 10.9l14.9-59.9c18.4 4.6 77.6 13.7 68.8 49zM308.6 220.2c-7.7 30.7-55 15.1-70.4 11.3l13.5-54.3c15.4 3.8 64.8 11 56.8 43z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/bitcoin.js
// module id = 570
// module chunks = 0